/**
 * Service URLs Configuration
 * SIMPLE, DIRECT, NO CACHE BULLSHIT
 */

// Check if we're in development mode
const isDev = import.meta.env.DEV || import.meta.env.MODE === 'development';

// Service URLs - HARDCODED and RELIABLE
export const SERVICE_URLS = {
  // Production (via Nginx gateway) - Use relative URLs so it works on any domain
  PRODUCTION: '',  // Empty string = relative URLs, nginx handles routing
  
  // Development (direct service ports)
  AUTH: 'http://localhost:3001',
  ANALYTICS: 'http://localhost:3002',
  SESSION: 'http://localhost:3003',
  AI: 'http://localhost:3005',
  COMPANY: 'http://localhost:3006',
};

/**
 * Get the correct service URL based on the endpoint
 * SIMPLE and DIRECT - no interceptor nonsense
 */
export function getServiceURL(url: string): string {
  // If already a full URL, return as is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // In production, use Nginx gateway
  if (!isDev) {
    return SERVICE_URLS.PRODUCTION;
  }
  
  // In development, route to specific service
  if (url.includes('/companies')) return SERVICE_URLS.COMPANY;
  if (url.includes('/analytics')) return SERVICE_URLS.ANALYTICS;
  if (url.includes('/anomalies')) return SERVICE_URLS.ANALYTICS;
  if (url.includes('/email-campaigns')) return SERVICE_URLS.ANALYTICS;
  if (url.includes('/aws-email-logs')) return SERVICE_URLS.ANALYTICS;
  if (url.includes('/email-analytics')) return SERVICE_URLS.ANALYTICS;
  if (url.includes('/eshops')) return SERVICE_URLS.ANALYTICS; // E-shops are in analytics service
  if (url.includes('/getresponse')) return SERVICE_URLS.ANALYTICS; // GetResponse integration
  if (url.includes('/betterstack')) return SERVICE_URLS.ANALYTICS; // BetterStack logs integration
  if (url.includes('/sessions')) return SERVICE_URLS.SESSION;
  if (url.includes('/ai')) return SERVICE_URLS.AI;
  
  // Default to auth service (/auth, /users, /roles)
  return SERVICE_URLS.AUTH;
}

/**
 * Build the complete URL with service and path
 */
export function buildURL(path: string): string {
  const serviceURL = getServiceURL(path);
  return `${serviceURL}${path}`;
}

